import { render, staticRenderFns } from "./CompanyShiftsForm.vue?vue&type=template&id=7b86fd68&"
import script from "./CompanyShiftsForm.vue?vue&type=script&lang=js&"
export * from "./CompanyShiftsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports